<script lang="ts">
	import type { ModalConfig, Modal } from '$lib/stores/modalStore.ts';
	import { closeModal } from '$lib/stores/modalStore.ts';
	import GlobalMedia from '$lib/components/media/GlobalMedia.svelte';

	export let open: boolean = false;
	export let config: ModalConfig | undefined = undefined;
	export let self: Modal | undefined = undefined;
</script>

<div
	class="modal variant-{config?.variant}"
	class:open
	class:no-background={config?.noBackground}
	class:mobile-fullscreen={config?.mobileFullScreen}
>
	<!-- {#if config?.dismissable}
		<div class="modal-close" on:click={() => self && closeModal(self.id)}>
			<GlobalMedia key="icon-close" />
		</div>
	{/if} -->
	<div class="modal-content">
		<slot />
	</div>
</div>

<style lang="scss">
	.modal {
		position: absolute;

		&:not(.no-background) {
			background: color(modal__background);
			border-radius: v(border-radius);
		}

		&.variant-bar {
			width: min(v(max-width-medium), calc(100% - 2 * v(page-padding)));
			min-height: v(cookies__banner__height);
			overflow: hidden;

			top: calc(100% - v(content-padding-lg));

			@include media(phone) {
				top: calc(100% - v(content-padding-lg));
			}

			inset-inline-start: 50%;
			transform: translate(-50%, -100%);

			display: flex;
			flex-direction: row;

			.modal-content {
				flex: 1;
				padding-block: v(content-gap-xs);
			}
		}

		&.variant-modal {
			padding: v(content-padding);
			padding-bottom: 0;

			width: min(600px, calc(100% - 2 * v(page-padding)));
			height: min(600px, calc(100% - v(header__height) - 2 * v(page-padding)));

			top: calc(50% + v(header__height) / 2);
			inset-inline-start: 50%;
			transform: translate(-50%, -50%);

			display: flex;
			flex-direction: column;

			.modal-content {
				flex: 1;
				padding-block: v(content-gap);
				overflow: auto;
			}
		}

		&.mobile-fullscreen {
			@include media(phone) {
				width: 100%;
				height: 100%;
				top: 50%;
			}
		}

		cursor: default;

		@include transition(all);

		&:not(.open) {
			top: 100%;
			transform: translate(-50%, 0);
		}

		.modal-close {
			position: absolute;
			top: v(content-gap-sm);
			inset-inline-end: v(content-gap-sm);
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 10;

			cursor: pointer;

			height: 2rem;
			width: 2rem;
			border-radius: v(border-radius-sm);
			// background: color(primary);
			color: color(white);
			@include transition;

			:global(svg) {
				width: 1.2rem;
				height: 1.2rem;
			}

			svg {
				path {
					fill: color(white);
				}
			}

			&:hover {
				scale: 1.1;
			}
		}
	}
</style>
